"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientRole = exports.Operation = void 0;
var Operation;
(function (Operation) {
    Operation["OPERATIVE"] = "OPERATIVE";
    Operation["ACCESS"] = "ACCESS";
})(Operation || (exports.Operation = Operation = {}));
var ClientRole;
(function (ClientRole) {
    ClientRole["CLIENT"] = "CLIENT";
    ClientRole["PROSPECT"] = "PROSPECT";
    ClientRole["EXPIRED_PASSWORD"] = "EXPIRED_PASSWORD";
})(ClientRole || (exports.ClientRole = ClientRole = {}));
//# sourceMappingURL=usdInformation.js.map